<template>
  <v-container class="white" grid-list-xl fluid ma-0 pa-0><br>
    <v-layout justify-left wrap class="white lighten-4 pa-1 caption"> 
      
      <v-card class="elevation-0 text-center white align-left"  max-width="90%">
        <v-flex xs12 md12>
          <v-col cols="12" md="12" sm="12" lg="12">
            <v-img
              :src="require('@/assets/pongal.jpg')"
              height="60%"
              width="90%"
            />
          </v-col>

          <v-card-text center>
          <v-img class="white--text" :src="require(`@/assets/zone1schedule.png`)" width="90%" max-height="100%"> </v-img>
        </v-card-text>
        </v-flex>

      </v-card>
    </v-layout>
  </v-container>    
</template>

<script>

export default {
  data: () => ({
    message: '',
  
  }),
}
</script>